import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {map, tap} from 'rxjs';

@Injectable()
export class CheckoutDataService {
  orderEndpoint = '/onStar/shop/order';

  constructor(private http: HttpClient) {
  }

  checkout(orderInfo: any, vehicle: any) {
    const onSuccess = (response: any) => {
      if (!response && !response.data) {
        return;
      }
      return response.data;
    };
    const vin = vehicle.vin;
    const ymmStr = vehicle.year + ',' + vehicle.make + ',' + vehicle.model;
    const checkoutUrl =
      '/pci/checkout/' + vin + '?urlkey=checkout&ymm=' + ymmStr;
    return this.http.post(checkoutUrl, orderInfo).pipe(map(onSuccess));
  }

  _getPostOrder(request: any) {
    const onSuccess = (response: any) => {
      if (response && response.data) {
        return response.data;
      }
    };
    return this.http.post(this.orderEndpoint, request).pipe(map(onSuccess));
  }

  getStatus(request: any) {
    const url = this.orderEndpoint.concat('/status');
    const onSuccess = (response: any) => {
      if (response && response.data) {
        return response.data;
      }
    };
    return this.http
      .get(url, {
        headers: request
      })
      .pipe(tap(onSuccess));
  }

  getPaymentMethods() {
    const url = '/checkout/paymentMethods';
    const onSuccess = (response: any) => {
      if (response && response.data) {
        return response.data;
      }
    };
    return this.http.get(url, {}).pipe(tap(onSuccess));
  }
}
